import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";
import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/layout';
import baseInfoServiceRouter from './modules/baseInfoService';
import systemAdminRouter from './modules/systemAdmin';
import yunyingAdminRouter from './modules/yunyingAdmin';
import yiyuanAdminRouter from './modules/yiyuanAdmin';
import queryStatisticsRouter from './modules/queryStatistics';
import followUpRouter from './modules/followUp';
import followUpHandleRouter from './modules/followUpHandle';
export var constantRoutes = [{
  path: '/login',
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: '/404',
  component: function component() {
    return import('@/views/404');
  },
  hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/myHomepage',
  name: 'myHomepage',
  children: [{
    path: 'myHomepage',
    name: 'myHomepage',
    component: function component() {
      return import('@/views/myHomepage/index');
    },
    meta: {
      title: '我的主页',
      icon: 'dashboard'
    }
  }]
}

// 404 page must be placed at the end !!!
// { path: '*', redirect: '/404', hidden: true },
];
//动态路由
export var asyncRouter = [yiyuanAdminRouter, yunyingAdminRouter, followUpRouter, followUpHandleRouter, queryStatisticsRouter, baseInfoServiceRouter, systemAdminRouter];
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: [].concat(constantRoutes)
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;